<template>
  <span class="svg-ico-tag">
    <svg
      v-if="isTwoTone"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49914 12.3811C11.0897 12.3811 12.3791 11.0917 12.3791 9.50109C12.3791 7.91051 11.0897 6.62109 9.49914 6.62109C7.90856 6.62109 6.61914 7.91051 6.61914 9.50109C6.61914 11.0917 7.90856 12.3811 9.49914 12.3811Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.70038 19.8308L4.17038 15.3008C3.22038 14.3508 2.71038 13.0408 2.77038 11.6908L3.01038 6.69078C3.11038 4.70078 4.70038 3.11078 6.70038 3.02078L11.7004 2.78078C13.0404 2.71078 14.3504 3.22078 15.3004 4.17078L19.8404 8.69078C21.7004 10.5608 21.7004 13.5808 19.8404 15.4408L15.4504 19.8308C13.5804 21.6908 10.5604 21.6908 8.70038 19.8308ZM9.49914 12.3811C11.0897 12.3811 12.3791 11.0917 12.3791 9.50109C12.3791 7.91051 11.0897 6.62109 9.49914 6.62109C7.90856 6.62109 6.61914 7.91051 6.61914 9.50109C6.61914 11.0917 7.90856 12.3811 9.49914 12.3811Z"
        :fill="color2"
      />
    </svg>
    <svg
      v-else-if="isSolid"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8305 8.70566L15.3005 4.17566C14.3505 3.22566 13.0405 2.71566 11.7005 2.78566L6.70046 3.02566C4.70046 3.11566 3.11046 4.70566 3.01046 6.69566L2.77046 11.6957C2.71046 13.0357 3.21046 14.3457 4.16046 15.2957L8.69046 19.8257C10.5505 21.6857 13.5705 21.6857 15.4405 19.8257L19.8305 15.4357C21.7005 13.5857 21.7005 10.5657 19.8305 8.70566ZM9.50046 12.3857C7.91046 12.3857 6.62046 11.0957 6.62046 9.50566C6.62046 7.91566 7.91046 6.62566 9.50046 6.62566C11.0905 6.62566 12.3805 7.91566 12.3805 9.50566C12.3805 11.0957 11.0905 12.3857 9.50046 12.3857Z"
        :fill="color"
      />
    </svg>
    <svg
      v-else
      class="icon-color-1"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6637 2.03167C13.2178 1.95128 14.7331 2.54248 15.8307 3.64006L20.3688 8.15862L20.3717 8.16155C22.5217 10.3232 22.524 13.8165 20.3707 15.9701L15.9791 20.3617C13.8174 22.5119 10.3232 22.5144 8.16956 20.3608L3.63929 15.8305C2.54046 14.7315 1.95179 13.2166 2.02113 11.6567V11.6547L2.26136 6.65471V6.65276C2.38067 4.27849 4.27776 2.3806 6.6637 2.2719L11.6637 2.03167ZM11.7389 3.52874L11.736 3.52971L6.73597 3.76897L6.73402 3.76995C5.1212 3.84252 3.84005 5.1231 3.75941 6.72796L3.51917 11.726C3.46924 12.8651 3.90037 13.9695 4.70081 14.7699L9.23011 19.3002C10.7964 20.8665 13.3433 20.868 14.9215 19.2983L19.3092 14.9096C20.8746 13.3442 20.878 10.8005 19.3112 9.2221L14.7711 4.70159L14.7701 4.70061C13.9684 3.89885 12.8638 3.46997 11.7389 3.52874Z"
        :fill="color"
      />
      <path
        d="M11.25 9.50022C11.25 8.53372 10.4665 7.75022 9.50002 7.75022C8.53352 7.75022 7.75002 8.53372 7.75002 9.50022C7.75002 10.4667 8.53352 11.2502 9.50002 11.2502C10.4665 11.2502 11.25 10.4667 11.25 9.50022ZM12.75 9.50022C12.75 11.2951 11.2949 12.7502 9.50002 12.7502C7.7051 12.7502 6.25002 11.2951 6.25002 9.50022C6.25002 7.7053 7.7051 6.25022 9.50002 6.25022C11.2949 6.25022 12.75 7.7053 12.75 9.50022Z"
        :fill="color"
      />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
